import { BaseBonusBoardDrawer } from './BaseBonusBoardDrawer';
import { webConfig } from '../../../core/applicationConfig';
import { FREE_SPIN_COUNT_STATE, MULTIPLIER_STATE, TOTAL_WIN_STATE } from '../../../stateManagment';

export class BonusBoardLandscapeDrawer extends BaseBonusBoardDrawer {
  constructor() {
    super();
    this.config = {
      space: 220,
      top: 1150,
      spaceTop: 150,
    };
  }

  setMultiplier() {
    const [content, onSet] = this.getMultiplier({ scale: .8 });
    this.setPosition(content, { x: webConfig.width - this.config.space, y: this.config.top });
    this.addSubscriber(MULTIPLIER_STATE.subscribe(onSet, true));
    this.container.addChild(content);
  }

  setFreeSpin() {
    const [content, onSet] = this.getFreeSpin({ scale: .8 });
    this.setPosition(content, { x: this.config.space, y: this.config.top });
    this.addSubscriber(FREE_SPIN_COUNT_STATE.subscribe(onSet, true));
    this.container.addChild(content);
  }

  setTotalWin() {
    const [content, onSet] = this.getTotalWin({ scale: .8 });
    this.setPosition(content, { x: webConfig.width / 2, y: this.config.spaceTop });
    this.addSubscriber(TOTAL_WIN_STATE.subscribe(onSet, true));
    this.container.addChild(content);
  }

  execute() {
    this.setMultiplier();
    this.setFreeSpin();
    this.setTotalWin();
  }
}